module.exports = __webpack_public_path__ + "static/media/delete.c23bc81e.svg";